import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getShopsData = params =>
  axios.get(`${API_HOST}/shops`, { params, withCredentials: true });

export const getShopMenuViewOrderData = () =>
  axios.get(`${API_HOST}/options/shopMenuViewOrder`, { withCredentials: true });

export const downloadShopData = params =>
  axios.get(`${API_HOST}/shops/download`, { params, withCredentials: true });

export const downloadShopEsData = params =>
  axios.get(`${API_HOST}/es/shops/download`, { params, withCredentials: true });

export const getShopDetailData = shopId =>
  axios.get(`${API_HOST}/shops/${shopId}`, { withCredentials: true });

export const addShopData = params =>
  axios.post(`${API_HOST}/shops`, params, { withCredentials: true });

export const editShopData = (shopId, params) =>
  axios.put(`${API_HOST}/shops/${shopId}`, params, { withCredentials: true });

export const editShopBankAccountData = (shopId, params) =>
  axios.post(
    `${API_HOST}/shops/bankAccount`,
    { ...params, shopId },
    { withCredentials: true }
  );

export const releaseShopData = shopId =>
  axios.put(`${API_HOST}/shops/${shopId}/release`, null, {
    withCredentials: true
  });

export const deleteShopData = shopId =>
  axios.delete(`${API_HOST}/shops/${shopId}`, { withCredentials: true });

export const addShopImageData = (shopId, params) =>
  axios.post(`${API_HOST}/shops/${shopId}/image`, params, {
    withCredentials: true
  });

export const downloadQrCodeData = shopId =>
  axios.post(`${API_HOST}/shops/${shopId}/qrcode/download`, null, {
    responseType: 'blob',
    // responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'image/jpeg'
    },
    withCredentials: true
  });

export const countShopEmailData = params =>
  axios.get(`${API_HOST}/shops`, { params, withCredentials: true });

export const addRelationShopData = params =>
  axios.post(`${API_HOST}/shops/relations`, params, { withCredentials: true });

export const addUnRelationShopData = (groupId, shopId) =>
  axios.delete(
    `${API_HOST}/groups/${groupId}/shops/${shopId}/relations`,
    null,
    {
      withCredentials: true
    }
  );

export const resetUserPasswordData = params =>
  axios.post(`${API_HOST}/shops/resetPassword`, params, {
    withCredentials: true
  });

export const closeShopData = params =>
  axios.post(`${API_HOST}/shops/close`, params, {
    withCredentials: true
  });

export const removeStripShopData = params =>
  axios.post(`${API_HOST}/shops/stripe/unlink`, params, {
    withCredentials: true
  });

export const statusShopData = params =>
  axios.post(`${API_HOST}/shops/status`, params, { withCredentials: true });

export const getZipCodeData = zipcode =>
  axios.get(`${API_HOST}/shops/zipcode/${zipcode}`, { withCredentials: true });

export const getShopsDataEs = params =>
  axios.get(`${API_HOST}/es/shops`, { params, withCredentials: true });

export const getPaymentSummaryShopData = params =>
  axios.get(`${API_HOST}/shops/paymentSummary`, {
    params,
    withCredentials: true
  });

export const sendMailPaymentDetailMonthData = month =>
  axios.post(`${API_HOST}/shops/sendDetail/${month}`, null, {
    withCredentials: true
  });

export const getShopConnectSystemData = shopId =>
  axios.get(`${API_HOST}/shops/shop-connect-system/${shopId}`, null, {
    withCredentials: true
  });

export const updateShopConnectSystemData = (shopId, params) =>
  axios.post(`${API_HOST}/shops/shop-connect-system/${shopId}`, params, {
    withCredentials: true
  });

export const linkPaymentShopData = params =>
  axios.put(`${API_HOST}/shops/paymentType/status`, params, {
    withCredentials: true
  });

export const changeUserPasswordData = params =>
  axios.post(`${API_HOST}/shops/changePassword`, params, {
    withCredentials: true
  });

export const getGochiTipSummaryData = params =>
  axios.get(`${API_HOST}/gochi-tip/summary/current-month`, {
    params,
    withCredentials: true
  });

export const getGochiTipUrlData = () =>
  axios.get(`${API_HOST}/shops/access-gochi-tip`, {
    withCredentials: true
  });

export const getInvoiceHistoryShopData = () =>
  axios.get(`${API_HOST}/shop/invoice/history`, {
    withCredentials: true
  });

export const getInvoiceShopData = params =>
  axios.get(`${API_HOST}/shop/invoice/list`, {
    params,
    withCredentials: true
  });

export const confirmInvoiceShopData = params =>
  axios.post(`${API_HOST}/shop/invoice/confirm`, params, {
    withCredentials: true
  });

export const listBatchShopData = params =>
  axios.get(`${API_HOST}/autoCreateShop/list`, {
    params,
    withCredentials: true
  });

export const validateBatchShopData = params =>
  axios.post(`${API_HOST}/autoCreateShop/validate`, params, {
    withCredentials: true
  });

export const batchShopImportFileData = params =>
  axios.post(`${API_HOST}/autoCreateShop/import`, params, {
    withCredentials: true
  });

export const sendShopReportData = (shopId, params) =>
  axios.post(`${API_HOST}/gochi-kid/shop/${shopId}/report`, params, {
    withCredentials: true
  });

export const getSettingGochiKidShopData = shopId =>
  axios.get(`${API_HOST}/gochi-kid/shop/${shopId}/setting`, {
    withCredentials: true
  });

export const getReportShopData = (shopId, month) =>
  axios.get(`${API_HOST}/gochi-kid/shop/${shopId}/report/month/${month}`, {
    withCredentials: true
  });

export const deleteSettingGochiKidShopData = shopId =>
  axios.delete(`${API_HOST}/gochi-kid/shop/${shopId}/setting`, {
    withCredentials: true
  });

export const updateSettingGochiKidShopData = (shopId, params) =>
  axios.put(`${API_HOST}/gochi-kid/shop/${shopId}/setting`, params, {
    withCredentials: true
  });

export const updateGochiKidFlagShopData = (shopId, params) =>
  axios.put(`${API_HOST}/gochi-kid/shop/${shopId}/can-use-setting`, params, {
    withCredentials: true
  });

export const updateShopSettingGochiKidUnlimitData = (shopId, params) =>
  axios.post(`${API_HOST}/shops/gochi-kid-unlimit/${shopId}`, params, {
    withCredentials: true
  });

export const updateAllowGapPaymentData = params =>
  axios.put(`${API_HOST}/shops/setting-allow-gap-payment`, params, {
    withCredentials: true
  });
